import app from '../../admin/app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Tooltip from '../../common/components/Tooltip';
import Alert from '../../common/components/Alert';
import LoadingModal from './LoadingModal';
import extractText from '../../common/utils/extractText';
export default class ResetExtensionSettingsModal extends Modal {
  loading = false;
  className() {
    return 'ResetExtensionSettingsModal Modal--medium';
  }
  title() {
    return this.attrs.title ?? app.translator.trans('core.admin.extension.reset_settings.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Alert, {
      type: "warning",
      dismissible: false
    }, app.translator.trans('core.admin.extension.reset_settings.warning')), m("ul", {
      className: "ResetExtensionSettingsModal-keys"
    }, this.attrs.settings.map(_ref => {
      let {
        key,
        label
      } = _ref;
      return m("li", null, m(Tooltip, {
        text: key,
        position: "right"
      }, m("span", null, label ? extractText(label) : key)));
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--danger",
      loading: this.loading,
      onclick: this.confirm.bind(this)
    }, app.translator.trans('core.admin.extension.reset_settings.confirm_button')), m(Button, {
      className: "Button",
      onclick: () => this.hide()
    }, app.translator.trans('core.admin.extension.reset_settings.cancel_button'))));
  }
  async confirm() {
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + '/settings',
        body: {
          keys: this.attrs.settings.map(_ref2 => {
            let {
              key
            } = _ref2;
            return key;
          }),
          extensionId: this.attrs.extensionId ?? ''
        }
      });
      this.hide();
      app.modal.show(LoadingModal);
      window.location.reload();
    } catch (e) {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('core', 'admin/components/ResetExtensionSettingsModal', ResetExtensionSettingsModal);